import { render } from "./DeliveryProvidersPage.vue?vue&type=template&id=7e644fcd&ts=true"
import script from "./DeliveryProvidersPage.vue?vue&type=script&lang=ts"
export * from "./DeliveryProvidersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__